import React, { ReactNode } from 'react';
import { Box } from '@mui/material';
import { palette } from '../../../assets/styles/themes/tokens';

interface PublicPageLayoutProps {
  children: ReactNode;
}

/**
 * Standalone layout for public pages that don't require authentication.
 * This is intentionally lightweight and doesn't include any authenticated-user
 * features like navigation, user profiles, or complex state management.
 */
const PublicPageLayout: React.FC<PublicPageLayoutProps> = ({ children }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100vh',
        backgroundColor: palette.background.default,
        overflow: 'hidden',
      }}
      data-testid='public-page-layout'
    >
      {children}
    </Box>
  );
};

export default PublicPageLayout;

